import React from 'react'
import { Paper, Typography } from '@mui/material'
import filterRoomGroupForScreen from '@app/helpers/scenes/filterRoomGroupForScreen'
import { SELECT_TRIGGERING_DEVICE_TYPE } from '@app/constants/routes'
import Wrapper from '@app/components/Common/Wrapper/Wrapper'
import NavBar from '@app/components/Common/NavBar/NavBar'
import PropTypes from '@app/components/PropTypes'
import GroupsList from '../../SelectDeviceCommon/GroupsList/GroupsList'

class SelectObservingGroup extends React.Component {
  onBackClick= () => {
    const {
      navigate,
    } = this.props
    navigate(SELECT_TRIGGERING_DEVICE_TYPE)
  }

  render() {
    const {
      classes,
      isMobile,
      groupsScenes,
      navigate,
    } = this.props
    const filteredGroups = filterRoomGroupForScreen(groupsScenes)
    return (
      <Paper className={classes.wrapper}>
        <NavBar
          title="create_scene"
          withButton={false}
          isMobile={isMobile}
          backClick={() => {
            this.onBackClick()
          }}
        />
        <Wrapper className={classes.titleWrapper}>
          <Typography className={classes.title}>{I18n.t('scene_web.select_observing_group')}</Typography>
        </Wrapper>
        <Wrapper className={classes.main}>
          <GroupsList
            navigate={navigate}
            groupsScenes={filteredGroups}
          />
        </Wrapper>
      </Paper>
    )
  }
}

SelectObservingGroup.propTypes = {
  classes: PropTypes.object.isRequired,
  navigate: PropTypes.func.isRequired,
  isMobile: PropTypes.bool.isRequired,
  groupsScenes: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
    number: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
  })).isRequired,
}

SelectObservingGroup.displayName = 'SelectObservingGroup'

export default SelectObservingGroup
